export const mapAnswers = (answers) => {
  let answersMap = {};
  Object.keys(answers).forEach((key) => {
    const answersByTypeMap = {};

    answers[key].forEach((answer) => {
      const { questionId, comment } = answer;
      if (comment) {
        if (!answersByTypeMap[`comment-${questionId}`]) {
          answersByTypeMap[`comment-${questionId}`] = comment;
        }
      }
      if (!answersByTypeMap[questionId]) {
        answersByTypeMap[questionId] = answer.answer;
      }
    });
    answersMap[key] = answersByTypeMap;
  });

  return answersMap;
};
